import React from 'react'
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  MenuItem,
  Button,
} from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import { onChangeEditHOF } from '../../utils/common'
import EditActionComponent from '../common/EditActionComponent'
import {
  metrcEnvironmentOptions as environmentOptions,
  getCaStates,
  getUsStates,
} from '../../utils/constants'

export default class MetrcMergedNewItem extends React.Component {
  onChange = onChangeEditHOF(this.props.onChange)

  onCancel = () => {
    this.props.onCancel()
    this.props.disableEdit()
  }

  onAddNewFacility = () => {
    /*this.props.onAddNewLocation(this.props.data);
    this.props.disableEdit();*/
  }
  render() {
    const { data, editMode, enableEdit } = this.props
    const allStates = [...getUsStates(), ...getCaStates()]

    const onEditingCells = (
      <React.Fragment>
        <TableCell>
          <EditableSelect
            valueToRender={data.stateCode || ''}
            value={data.stateCode || ''}
            editMode={editMode}
            onChange={this.onChange('stateCode')}
          >
            {allStates.map((option, index) => {
              return (
                <MenuItem key={index} value={option.value}>
                  {option.value}
                </MenuItem>
              )
            })}
          </EditableSelect>
        </TableCell>
        <TableCell>
          <EditableSelect
            valueToRender={data.environment}
            editMode={editMode}
            value={data.environment}
            onChange={this.onChange('environment')}
          >
            {environmentOptions.map((env) => {
              return <MenuItem value={env.value}>{env.label}</MenuItem>
            })}
          </EditableSelect>
        </TableCell>

        <TableCell>
          <Grid container>
            <Grid item sm={10}>
              <EditableTextField
                valueToRender={data.userApiKey}
                editMode={editMode}
                value={data.userApiKey}
                onChange={this.onChange('userApiKey')}
                type="text"
              />
            </Grid>
            <Grid item sm={2}>
              {editMode ? (
                <SearchIcon
                  style={{
                    cursor: 'pointer',
                  }}
                  //onClick={checkApiKey(index)}
                />
              ) : null}
            </Grid>
          </Grid>
        </TableCell>
        <TableCell className="cell-wrap-word">
          <Grid item sm={10}>
            {data.stateCode ? (
              <EditableSelect
                sm={12}
                valueToRender={data.facLicense}
                value={data.facLicense}
                editMode={editMode}
                onChange={this.onChange('facLicense')}
              >
                {!data.stateCode ? (
                  <MenuItem value={null}>Please select state code.</MenuItem>
                ) : null}
                {/*facilityOptions.map((option, index) => {
                  return (
                    <MenuItem key={index} value={option.License.Number} sm={10}>
                      {option.License.Number} ({option.Name} |{" "}
                      {option.License.LicenseType})
                    </MenuItem>
                  );
                })*/}
              </EditableSelect>
            ) : (
              <span>Please select facility.</span>
            )}
          </Grid>
        </TableCell>
        <TableCell>
          <EditableSwitch
            valueToRender={data.enabled ? 'Enabled' : 'Disabled'}
            checked={data.enabled}
            editMode={editMode}
            onChange={this.onChange('enabled', true)}
          />
        </TableCell>
        <TableCell>
          <EditableSwitch
            valueToRender={data.enableSync ? 'Enabled' : 'Disabled'}
            checked={data.enableSync}
            editMode={editMode}
            onChange={this.onChange('enableSync', true)}
          />
        </TableCell>
        <TableCell>
          <EditableSwitch
            valueToRender={data.enableDeliveryTransaction ? 'Enabled' : 'Disabled'}
            checked={data.enableDeliveryTransaction}
            editMode={editMode}
            onChange={this.onChange('enableDeliveryTransaction', true)}
          />
        </TableCell>
        <TableCell>
          <EditActionComponent
            onSave={this.onAddNewFacility}
            onCancel={this.onCancel}
            onEdit={this.props.enableEdit}
            editMode={editMode}
          />
        </TableCell>
      </React.Fragment>
    )

    return (
      <React.Fragment>
        {editMode ? (
          onEditingCells
        ) : (
          <TableCell>
            <Button outlined="contained" color="primary" onClick={enableEdit}>
              Add
            </Button>
          </TableCell>
        )}
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/MetrcMergedNewItem.js